<template>
  <div class="Payment">
    <div class="body">
      <div class="title">
        微信支付
      </div>
      <div class="panel">
        <div class="span">
          订单创建成功，支付成功后即可获取题目并可获得AI HackStack的使用许可证！
        </div>
        <div class="subtitle">
          扫码支付
        </div>
        <qrcode-vue v-if="url" :size="200" :value="url" level="H" render-as="svg"/>
        <div v-else>
          ...
        </div>
      </div>
    </div>

  </div>

</template>
<script>
import QrcodeVue from 'qrcode.vue'
export default {
  name: 'Payment',
  components: {
    QrcodeVue
  },
  data () {
    return {
      url: ''
    }
  },
  mounted () {
    this.$http.post('/api/payment/create', {
    }).then(res => {
      console.log(res)
      this.url = res.data.code_url
    })
  }
}

</script>
<style scoped>
.Payment {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.body {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.title {
  font-size: 20px;
  font-weight: bold;
}
.subtitle {
  margin-top: 50px;
}
.panel {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>